export default __webpack_public_path__ + "static/media/thumb-up.93d8d6f6.svg";